module.exports = __webpack_public_path__ + "img/groupcisc-contact.20923580.png";